import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.DOUBLE_TROUBLE;

export const CONTENT_VERSION = '0.0.1';

export const OBJECT_PLACEMENT_METHODS = {
  DEFAULT: 'DEFAULT',
  RANDOM_SIDE: 'RANDOM_SIDE',
  FULL_RANDOM: 'FULL_RANDOM',
};

export const OBJECT_PLACEMENT_METHOD = OBJECT_PLACEMENT_METHODS.FULL_RANDOM;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
};

export const OBJECT_PLACEMENT_TYPES = {
  A: 'A',
  B: 'B',
  BOTH: 'BOTH',
  NONE: 'NONE',
};

export const OBJECT_PLACEMENT_CORRESPONDING_ANSWERS = {
  [`${OBJECT_PLACEMENT_TYPES.A}`]: 'B',
  [`${OBJECT_PLACEMENT_TYPES.B}`]: 'A',
  [`${OBJECT_PLACEMENT_TYPES.BOTH}`]: 'TRASH',
  [`${OBJECT_PLACEMENT_TYPES.NONE}`]: 'TRASH',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  ENABLE_SCENE_ELEMENT: 'ENABLE_SCENE_ELEMENT',
  INCREMENT_OBJECT_INDEX: 'INCREMENT_OBJECT_INDEX',
  INCREMENT_SCENE_INDEX: 'INCREMENT_SCENE_INDEX',
  RESET_ROUND: 'RESET_ROUND',
  START_ROUND: 'START_ROUND',
  START_DRAG: 'START_DRAG',
  SET_CURRENT_HOVER_TARGET: 'SET_CURRENT_HOVER_TARGET',
  MAKE_SELECTION: 'MAKE_SELECTION',
  SET_DRAGGABLE: 'SET_DRAGGABLE',
};

export const TARGET_STATES = {
  INACTIVE: 'INACTIVE',
  AVAILABLE: 'AVAILABLE',
  HOVERED: 'HOVERED',
};

export const TARGET_AREAS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TRASH: 'TRASH',
  NONE: 'NONE',
};

export const OBJECTS_PER_SCENE = 5;
export const SCENES_PER_ROUND = 3;

// searchlight actions
export const SEARCHLIGHT_DISPATCH_EVENT = 'SEARCHLIGHT_DISPATCH_EVENT';
